import styled from "styled-components";
import Button from "react-bootstrap/Button";
import { useRouteLineContext } from "../../../../context/MapViews/RouteLine/RouteLineContext";
import SelectedRouteLinesView from "../../../map/views/routeline/overlays/SelectedRouteLinesView";
import { MapView } from "../../../../constant/VectorTileLayerType";
import { useLocation } from "react-router-dom";

const SidebarContainer = styled.div<{ $show: boolean }>`
  max-width: ${({ $show }) => ($show ? "350px" : "0")};
  opacity: ${({ $show }) => ($show ? "1" : "0")};
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition:
    max-width 0.3s ease,
    opacity 0.3s ease;
`;

const SidebarInner = styled.div`
  width: 350px;
  padding: 0.5rem;
`;

const CloseButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 0.5rem 0 0.25rem;
`;

const RoutelineSidebar = () => {
  const {
    routeLines,
    selectedRouteLine,
    setSelectedRouteLine,
    setShowOverlay,
  } = useRouteLineContext();

  const location = useLocation();
  const show = Boolean(
    routeLines &&
    routeLines.length > 0 &&
    selectedRouteLine != null &&
    location.pathname.includes(MapView.ROUTE_LINE),
  );

  return (
    <SidebarContainer $show={show} className={show ? "bg-light" : ""}>
      <SidebarInner>
        {routeLines && selectedRouteLine && (
          <>
            <SelectedRouteLinesView
              routeLines={routeLines}
              selectedRouteLine={selectedRouteLine}
            />
            <CloseButtonRow>
              <Button
                variant="primary"
                onClick={() => {
                  setShowOverlay(true);
                  setSelectedRouteLine(null);
                }}
              >
                Close
              </Button>
            </CloseButtonRow>
          </>
        )}
      </SidebarInner>
    </SidebarContainer>
  );
};

export default RoutelineSidebar;
